module.exports = __webpack_public_path__ + "img/receipt.7a1486bd.svg";